import { createActionDuck } from "../helpers/action";
import { createUseItem } from "../helpers/fetchHooks";
import createItemFetcher from "../helpers/item";
import { createNotificationsEpic } from "../helpers/notifications";
const computeMultiEditTragetsUrl = ({ scenario, workspace, program, mode, panelName }) => {
    return `/api/v1/multidat/${scenario}/${workspace}/${program}/${mode}/${panelName}/targets`;
};
const computeMultiEditTragetsId = ({ scenario, workspace, program, mode, panelName }) => {
    return `${scenario}_${workspace}_${program}_${mode}_${panelName}`;
};
export const multiEditTargetItemDuck = createItemFetcher(computeMultiEditTragetsUrl, "MULTIEDIT_TARGETS", computeMultiEditTragetsId, payload => payload.collection.items);
export const createMultiEditConfig = () => {
    return multiEditTargetItemDuck;
};
export const useMultiEdit = createUseItem(multiEditTargetItemDuck, state => state.multiEditConfig);
const computesaveMultiEditId = () => {
    return `multidat`;
};
const computesaveMultiEditUrl = () => ({
    url: `/api/v1/multidat`,
    method: "POST"
});
export const saveMultiEditDuck = createActionDuck("MultiEditSave", computesaveMultiEditUrl, computesaveMultiEditId);
saveMultiEditDuck.middleware = saveMultiEditDuck.middleware.concat(createNotificationsEpic(saveMultiEditDuck.ActionKeys, "save Multiple Panel Edition"));
export const createMultiEditSave = () => {
    return saveMultiEditDuck;
};
//# sourceMappingURL=index.js.map